/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscriptions_TitleInputs */

const en_admin_subscriptions_title = /** @type {(inputs: Admin_Subscriptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscriptions`)
};

const zh_admin_subscriptions_title = /** @type {(inputs: Admin_Subscriptions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅管理`)
};

/**
* | output |
* | --- |
* | "Subscriptions" |
*
* @param {Admin_Subscriptions_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_subscriptions_title = /** @type {((inputs?: Admin_Subscriptions_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscriptions_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_subscriptions_title(inputs)
	return zh_admin_subscriptions_title(inputs)
});
export { admin_subscriptions_title as "admin.subscriptions.title" }